// extracted by mini-css-extract-plugin
export default {"servicesDiv":"Services_servicesDiv__S3Fwf","cardsContainer":"Services_cardsContainer__uH-ST","zoomIn":"Services_zoomIn__xhkeD"};